import { useIntl, FormattedMessage } from 'react-intl';

import { Icon } from 'cosmos-components';

import msg from './retrieveSelfCheckInMessages';
import {
    StyledContentWrapper,
    StyledContent,
} from './retrieveSelfCheckIn.component';

export const LandingTextCA = () => {
    const intl = useIntl();
    return (
        <StyledContentWrapper>
            <StyledContent>
                <b>{intl.formatMessage(msg.content.welcomeTo)}</b>
            </StyledContent>
            <StyledContent>
                {intl.formatMessage(msg.content.checkInOpens, {
                    days: 5,
                })}
            </StyledContent>
            <StyledContent />
            <StyledContent>
                <FormattedMessage
                    {...msg.content.headsUp}
                    values={{
                        headsUpBoldText: intl.formatMessage(
                            msg.content.headsUpBoldText,
                        ),
                        minutes: 60,
                    }}
                />
            </StyledContent>
            <StyledContent>
                <hr />
            </StyledContent>
            <StyledContent>
                <b>{intl.formatMessage(msg.content.duringCheckIn)}</b>
                <ul>
                    <li>
                        {intl.formatMessage(msg.content.contactDetails)}
                    </li>
                    <li>{intl.formatMessage(msg.content.licenceDetails)}</li>
                    <li>{intl.formatMessage(msg.content.additionalDrivers)}</li>
                    <li>{intl.formatMessage(msg.content.demoVideosUSCA)}</li>
                    <li>{intl.formatMessage(msg.content.travelExtrasUSCA)}</li>
                    <li>{intl.formatMessage(msg.content.outstanding)}</li>
                    <li>
                        {intl.formatMessage(msg.content.insurancePolicyUSCA)}
                    </li>
                </ul>
            </StyledContent>
            <StyledContent>
                <hr />
            </StyledContent>
            <StyledContent>
                <Icon name="tickSquared" color="green" />
                {intl.formatMessage(msg.content.tip)}
            </StyledContent>
            <StyledContent>
                <Icon name="warning" color="orange" />
                {intl.formatMessage(msg.content.importantInfo)}
            </StyledContent>
            <StyledContent />
            <StyledContent>
                {intl.formatMessage(msg.content.subTextUs)}
            </StyledContent>
        </StyledContentWrapper>
    );
};
